import { render, staticRenderFns } from "./Plans.vue?vue&type=template&id=3eaa7ede&lang=pug&"
import script from "./Plans.vue?vue&type=script&lang=ts&"
export * from "./Plans.vue?vue&type=script&lang=ts&"
import style0 from "./Plans.vue?vue&type=style&index=0&id=3eaa7ede&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports